import { memo as Memo, useState, useRef, useCallback } from 'react'

//* GSAP
import gsap from 'gsap'

//* Components
import Container from 'components/common/Container'
import Video from 'components/common/Video'
import Text from 'components/common/Text'
import Icon from 'components/common/Icon'

//* Style
import MakeVideoStyle from './style'

const MakeVideo = Memo(({ className, title, src }) => {
	//! State
	const [play, setPlay] = useState(true)

	//! Refs
	const cursorRef = useRef()
	const videoContRef = useRef()

	//! Handle click
	const handleClick = useCallback(() => {
		if (play) {
			setPlay(false)
		} else {
			setPlay(true)
		}
	}, [play])

	//! Handle mouse move
	const handleMouseMove = useCallback((e) => {
		const videoContRect = videoContRef.current.getBoundingClientRect()
		const x = e.clientX - videoContRect.left
		const y = e.clientY - videoContRect.top

		gsap.to(cursorRef.current, { duration: 0.3, opacity: 1, left: x, top: y, scale: 1 })
	}, [])

	//! Handle mouse leave
	const handleMouseLeave = useCallback(() => {
		gsap.to(cursorRef.current, { duration: 0.3, opacity: 0, scale: 0 })
	}, [])

	return (
		<MakeVideoStyle className={`make-video ${className || ''}`}>
			<Container>
				<Text
					tag={`h4`}
					className={`h4 minion3-medium primary-color9 uppercase align-center`}
					text={title}
				/>

				<Container
					row
					full
					className={`make-video-container`}
				>
					<div className={`empty col-1 col-t-12`} />

					<div
						ref={videoContRef}
						onMouseMove={handleMouseMove}
						onMouseLeave={handleMouseLeave}
						className={`make-video-wrapper col-10 col-t-12`}
					>
						<Video
							src={src}
							loop={true}
							controls={false}
							autoplay={false}
							handleClick={handleClick}
						/>

						<div
							ref={cursorRef}
							className={`play-and-pause-cursor-wrap`}
						>
							<Icon
								name={`${play ? 'play' : 'pause'}`}
								className={`play-and-pause-cursor`}
							/>
						</div>
					</div>

					<div className={`empty col-1 col-t-12`} />
				</Container>
			</Container>
		</MakeVideoStyle>
	)
})

export default MakeVideo
